import {
  ClipboardList,
  Code2,
  Database,
  Activity,
  Eye,
  ArrowRightLeft,
} from "lucide-react";

const XENON_FEATURES = [
  {
    id: "01",
    title: "TestPlan Agent",
    summary: "Auto-generates context-aware Salesforce test cases.",
    icon: <ClipboardList size={18} />,
    color: "#0ea5e9",
  },
  {
    id: "02",
    title: "AutoScript Agent",
    summary: "Metadata-driven Selenium & Playwright scripting.",
    icon: <Code2 size={18} />,
    color: "#f59e0b",
  },
  {
    id: "03",
    title: "TDM Agent",
    summary: "Natural language test data generation with relations.",
    icon: <Database size={18} />,
    color: "#10b981",
  },
  {
    id: "04",
    title: "Execute Agent",
    summary: "Unified execution engine with real-time reporting.",
    icon: <Activity size={18} />,
    color: "#ef4444",
  },
  {
    id: "05",
    title: "In-Sprint Agent",
    summary: "UI-diff analysis for automated test maintenance.",
    icon: <Eye size={18} />,
    color: "#6366f1",
  },
  {
    id: "06",
    title: "PW Migration Agent",
    summary: "Scalable Selenium to Playwright migration.",
    icon: <ArrowRightLeft size={18} />,
    color: "#334155",
  },
];

export default XENON_FEATURES;
